import React, { useEffect, useRef } from 'react';
import SEOHead from '../components/Common/SEOHead';
import LandingHeroSection from '../components/Landing/LandingHeroSection';
import LandingSocialProofImageSection from '../components/Landing/LandingSocialProofImageSection';
import LandingFeaturesSection from '../components/Landing/LandingFeaturesSection';
import LandingFinalConversionSection from '../components/Landing/LandingFinalConversionSection';
import LandingFooter from '../components/Landing/LandingFooter';
import { getLandingIMessageHref } from '../components/Landing/LandingConstants';
import '../styles/landing/LandingPage.css';

const LandingPage = () => {
  const pageRef = useRef(null);

  useEffect(() => {
    const el = pageRef.current;
    if (!el) return;
    const reveals = el.querySelectorAll('.landing-reveal');
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('landing-reveal--visible');
          }
        });
      },
      { threshold: 0.08, rootMargin: '0px 0px -20px 0px' }
    );
    reveals.forEach((r) => observer.observe(r));
    return () => observer.disconnect();
  }, []);

  return (
    <div className="landing-page" ref={pageRef}>
      <SEOHead pageType="landing" />
      <header className="landing-header">
        <div className="landing-header__inner">
          <a
            href={getLandingIMessageHref()}
            className="landing-header__cta"
            rel="noopener noreferrer"
          >
            Book a Yacht Today — Get a FREE 1-Hour Jet Ski on Us. Limited Time.
          </a>
        </div>
      </header>
      <div className="landing-reveal">
        <LandingHeroSection />
      </div>
      <div className="landing-reveal">
        <LandingSocialProofImageSection />
      </div>
      <div className="landing-reveal">
        <LandingFeaturesSection />
      </div>
      <div className="landing-reveal">
        <LandingFinalConversionSection />
      </div>
      <div className="landing-reveal">
        <LandingFooter />
      </div>
    </div>
  );
};

export default LandingPage;
